import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.695 17H0V33.894H65.695V17Z" fill="white" />
    <path d="M65.695 0H0V17H65.695V0Z" fill="#D80027" />
    <path d="M66 34.106H0.304993V51H66V34.106Z" fill="#6DA544" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
